export const action = {
    VIEW_DOCUMENT: {
        action: 'VIEW_DOCUMENT',
        pastAction: 'visualizou'
    },
    DOWNLOAD_DOCUMENT: {
        action: 'DOWNLOAD_DOCUMENT',
        pastAction: 'baixou'
    },
}